export default __webpack_public_path__ + "static/ControllerR-d18da405f2ec5606bc12960a3f9f7a28.svg";